var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCategory5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 108,
    rx: 54,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M75 33H33C29.15 33 26 36.15 26 40V41.925C28.065 40.735 30.445 40 33 40H75C77.555 40 79.935 40.735 82 41.925V40C82 36.15 78.85 33 75 33Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75 26H33C25.265 26 19 32.265 19 40V68C19 75.735 25.265 82 33 82H75C82.735 82 89 75.735 89 68V40C89 32.265 82.735 26 75 26ZM68.49 60.195C67.65 60.895 66.495 61.175 65.41 60.895L26.525 51.375C27.575 48.82 30.06 47 33 47H75C77.345 47 79.41 48.19 80.705 49.94L68.49 60.195ZM82 41.925C79.935 40.735 77.555 40 75 40H33C30.445 40 28.065 40.735 26 41.925V40C26 36.15 29.15 33 33 33H75C78.85 33 82 36.15 82 40V41.925Z",
    fill: "#426DD8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M33.0004 47H75.0004C77.3454 47 79.4104 48.19 80.7054 49.975L68.4904 60.195C67.6504 60.895 66.4954 61.175 65.4104 60.895L26.5254 51.375C27.5754 48.82 30.0604 47 33.0004 47Z",
    fill: "#D1DEFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory5);
export default __webpack_public_path__ + "static/media/category5.ff21f9265e5890961e59d95f81c85af6.svg";
export { ForwardRef as ReactComponent };